import type { ReactNode, JSX} from "react";
import { Stack } from "./Stack";
import { Row } from "./Row";
import { Text } from "./Text";

export interface SidebarSectionProps {
  readonly title: string;
  readonly pill?: string;
  readonly children: ReactNode;
}

/**
 * A section in the right sidebar with a title and optional count pill.
 * Used across inbox, emails, meetings, companies, tasks sidebars.
 */
export function SidebarSection({ title, pill, children }: SidebarSectionProps): JSX.Element {
  return (
    <Stack gap={2}>
      <Row gap={2} align="center" className="mb-2.5">
        <Text variant="body" weight="semibold">{title}</Text>
        {pill ? (
          <span className="bg-accent text-white text-[11px] rounded-full px-1.5 py-0.5">
            {pill}
          </span>
        ) : null}
      </Row>
      {children}
    </Stack>
  );
}
